export default function presetsListController($q, presetsService, $log, $mdDialog, $state, $scope, $timeout, $document, errorDialogOpen,
                                              listManagementFactory, pusherChannel, $translate) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  let iconsRequire = require.context('@printos/imposer-ui/src/components/templates/images/icons', false, /\.svg/);
  vm.defaultIcon = iconsRequire("./star_checked.svg");
  vm.lockIcon = iconsRequire("./lock.svg");
  vm.duplicateDisabled = false;
  vm.initializing = true;

  (function init() {
    vm.listUtility = listManagementFactory.getMonitoringListService();

    let listInitParams = {
      listName : 'ComposerPresetsList',
      fetchListByPageFunc : getListOfElements,
      getChannelNameFunc : pusherChannel.getChannelName,
      entryUUIDFieldName : "id",
      entryIdentificationFieldName : "id",
      entryNameFieldName : "name",
      listOfDateAttributesToFormat : ['creationTime'],
      placeToAddNewElementToList: listManagementFactory.addNewToBeginningOfList,
      isMultiSelect: true,
      pagination : {
        limit:15,
        page:1,
        elementsPerPageOptions:[15,20,30]
      },
      events : {
        addedEntry : "PRESET_LIST_ENTRY_ADDED",
        deletedEntry : "PRESET_LIST_ENTRY_DELETED",
        changedEntry : "PRESET_LIST_ENTRY_CHANGED"
      },
      callbacks : {
        onAddedEntry : onAddedEntry,
        onDeletedEntry : null,
        onChangedEntry : onChangedEntry,
        onFileSelect : null,
        actionBeforeDeletion : null,
        actionBeforeAddedChanged : null,
        actionBeforeChangedOnOldData : null
      }
    };

    vm.listUtility.initialize(listInitParams);
  })();

  vm.isDeletionAllowed = function(){
    return vm.listUtility.selected.length > 0 && vm.listUtility.selected.filter(curr => curr.predefined === true || curr.default === true).length === 0;
  };

  vm.isEditAllowed = function(){
    return vm.listUtility.selected.length === 1 && vm.listUtility.selected.filter(curr => curr.predefined === true).length === 0;
  };

  vm.linkedTemplates = function(preset){
    let functionName = 'presetsController.linkedTemplates';
    $log.info(angular.toJson({action: 'function called', functionName: functionName, preset: preset}));

    presetsService.getLinkedTemplates([preset.id]).then(listOfUsingTemplates => {
      openUnlinkTemplatesDialog([preset], listOfUsingTemplates);
    });
  };

  function openUnlinkTemplatesDialog(presets, listOfUsingTemplates){
    let functionName = 'presetsController.openUnlinkTemplatesDialog';
    $log.info(angular.toJson({action: 'function called', functionName: functionName, presets: presets}));

    let defer = $q.defer();

    let isDefault = false;
    let presetName = null;
    if(presets && presets.length === 1){
      isDefault = presets[0].default;
      presetName = presets[0].name;
    }

    let elementTypeName = $translate.instant('imposer.composer-main.presets');

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('@printos/imposer-ui/src/components/common/usage-dialog/usage-dialog.html'),
      controller: 'usageDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        title: 'imposer.composer-main.preset_links',
        numberOfElements: presets.length,
        listOfLinkedElements: listOfUsingTemplates,
        elementName: presetName,
        isLocked: isDefault,
        elementTypeName: elementTypeName,
        linkedElementsTypeName:  'imposer.composer-main.Templates',
        unlinkFunc: presetsService.unlinkTemplates,
        showElementFunc: showTemplateDetails
      }
    }).then(function (data) {
      $log.info(angular.toJson({action: 'dialog closed successfully', functionName: functionName}));
      defer.resolve(data);
    }, error => {
      defer.reject(error);
    });

    function showTemplateDetails(templateId){
      $state.transitionTo('templates.templatedetails', {composerTemplateId: templateId});
    }

    return defer.promise;
  }

  vm.delete = function(event){
    let functionName = 'presetsController.delete';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));

    let listOfElementsToDelete = vm.listUtility.selected.map(curr => curr.id);

    let elementName = '';
    if (vm.listUtility.selected.length === 0) {
      return;
    }else if(vm.listUtility.selected.length === 1){
      elementName = vm.listUtility.selected[0].name;
    }

    let selectedIds = vm.listUtility.selected.map(preset => preset.id);
    presetsService.getLinkedTemplates(selectedIds).then(listOfUsingTemplates => {
      if(listOfUsingTemplates) {
        if (listOfUsingTemplates.length === 0) {
          openDeletionDialog();
        } else {
          openUnlinkTemplatesDialog(vm.listUtility.selected, listOfUsingTemplates).then(listOfUsingTemplates => {
            if (listOfUsingTemplates.length === 0) {
              openDeletionDialog();
            }
          });
        }
      }
    });



    $log.info(angular.toJson({action: 'function return', functionName: functionName}));

    function openDeletionDialog(){
      $mdDialog.show({
        parent: angular.element(document.body),
        targetEvent: event,
        clickOutsideToClose: false,
        escapeToClose: true,
        template: require('./delete-presets/preset-delete.html'),
        controller: 'presetDeleteController',
        bindToController: true,
        controllerAs: 'vm',
        locals: {
          listOfElementToDelete: listOfElementsToDelete,
          elementName: elementName,
          deleteFunc: deletePresets
        }
      }).then(function (data) {
        $log.info(angular.toJson({action: 'dialog closed successfully', functionName: functionName}));
      });
    }
  };

  vm.duplicate = function(){
    let functionName = 'presetsListController.duplicate';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));

    vm.duplicateDisabled = true;
    let preset = angular.copy(vm.listUtility.selected[0]);

    presetsService.duplicatePreset(preset.id).then(duplicatedPreset => {
      if(duplicatedPreset.sameNameIndex > 0){
        duplicatedPreset.name = duplicatedPreset.name + '-' + duplicatedPreset.sameNameIndex;
      }
      $state.transitionTo('presets.presetdetails', {
        presetId: duplicatedPreset.id,
        preset: duplicatedPreset,
        mode: 'update'
      }).then(()=> {
        vm.duplicateDisabled = false;
      });

      $log.info(angular.toJson({action: 'function return', functionName: functionName}));
    });
  };

  vm.add = function(){
    let functionName = 'presetsListController.add';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));

    event.preventDefault();
    event.stopPropagation();

    presetsService.getPredefinedPreset().then(defaultPreset =>{
      $state.transitionTo('presets.presetdetails', {
        presetId: defaultPreset.id,
        preset: defaultPreset,
        mode: 'new'
      });
    }, error => {
      errorDialogOpen.openErrorDialog(error);
    });

    $log.info(angular.toJson({action: 'function return', functionName: functionName}));
  };

  vm.setAsDefault = function(presetEntry, event){
    let functionName = 'presetsListController.setAsDefault';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));

    event.preventDefault();
    event.stopPropagation();

    let confirmMessage = $translate.instant('imposer.composer-main.preset_set_default_confirm',[presetEntry.name]);
    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('@printos/imposer-ui/src/components/common/confirm-dialog/confirmDialog.html'),
      controller: 'confirmDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        title: 'imposer.composer-main.preset_make_default',
        confirmMessage: confirmMessage,
      }
    }).then(function () {
      presetsService.setAsDefault(presetEntry.id);
      $log.info(angular.toJson({action: 'dialog closed successfully', functionName: functionName}));
    });
  };

  vm.showDetails = function(event, preset){
    let functionName = 'presetsListController.showDetails';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));

    event.preventDefault();
    event.stopPropagation();

    if (!preset) {
      preset = vm.listUtility.selected[0];
    } else {
      vm.listUtility.theList.map(curr => {
        if(curr.id !== preset.id){
          curr.isSelected = false;
        }
      });
      preset.isSelected = true;
      vm.listUtility.selected = [preset];
    }

    $state.transitionTo('presets.presetdetails', {
      presetId: preset.id,
      preset: preset,
      mode: 'update'
    });

    $log.info(angular.toJson({action: 'function return', functionName: functionName}));
  };

  function getListOfElements(page, pageSize, searchFilter) {
    vm.initializing = true;
    let defer = $q.defer();
    presetsService.getPresetsByPage(page, pageSize, searchFilter).then(response => {
      if(response) {
        $translate.onReady(()=> {
          response.listOfElements = response.listOfElements.map(preset => {
            if (preset.predefined) {
              preset.name = $translate.instant('imposer.composer-main.' + preset.name);
            }

            preset.preferredModeForDisplay = $translate.instant('imposer.composer-main.preset_' + preset.preferredMode.toLowerCase());

            return preset;
          });
        });
        defer.resolve(response);
        vm.initializing = false;
      }else{
        defer.reject(error);
      }
    },error => {
      defer.reject(error);
    });
    return defer.promise;
  }

  function deletePresets(presetIdsToDelete) {
    let functionName='presetDeleteController.deletePresets';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    let defer = $q.defer();

    vm.isInProgress = true;
    presetsService.deletePresets(presetIdsToDelete).then(response => {
      defer.resolve(response);
    }, error => {
      defer.reject(error);
    });
    $log.info(angular.toJson({action:'function return', functionName:functionName}));

    return defer.promise;
  }

  function onChangedEntry(changedEntry){
    if(changedEntry) {
      if (changedEntry.isDefault !== undefined) {
        changedEntry.default = changedEntry.isDefault;
      }
      if (changedEntry.isPredefined !== undefined) {
        changedEntry.predefined = changedEntry.isPredefined;

        if (changedEntry.predefined) {
          changedEntry.name = $translate.instant('imposer.composer-main.' + changedEntry.name);
        }
      }
      changedEntry.preferredModeForDisplay = $translate.instant('imposer.composer-main.preset_' + changedEntry.preferredMode.toLowerCase());
    }
  }

  function onAddedEntry(addedEntry){
    if(addedEntry) {
      if (addedEntry.isDefault !== undefined) {
        addedEntry.default = addedEntry.isDefault;
      }
      if (addedEntry.isPredefined !== undefined) {
        addedEntry.predefined = addedEntry.isPredefined;
      }
      addedEntry.preferredModeForDisplay = $translate.instant('imposer.composer-main.preset_' + addedEntry.preferredMode.toLowerCase());
    }
  }

  $scope.$on('$destroy', function () {
    vm.listUtility.close();
  });
}
export const name = 'presetsListController';
